export class Menu {

    menuOperador = [
        {
          label: 'Bandeja de Pedidos',
          link: 'bandejapedidos',
          icon: 'offline_pin'
        }
    ];

    menuAdmin = [
        {
          label: 'Bandeja de Pedidos',
          link: 'bandejapedidos',
          icon: 'offline_pin'
        },
        {
          label: 'Gestion de Publicaciones',
          faIcon: 'fab fa-500px',
          items: [
            
            
            
            {
              label: 'Publicaciones',
              faIcon: 'far fa-newspaper',
              link: 'mantBook',
            },
            
          ]
        },
        // {
        //   label: 'Gestion de Productos',
        //   faIcon: 'fab fa-500px',
        //   items: [           
        //     {
        //       label: 'productos',
        //       link: 'mantProducto',
        //       faIcon: 'far fa-newspaper',
        //     },
        //     {
        //       label: 'inventario Stock',
        //       link: 'mantinventarioprod',
        //       faIcon: 'far fa-newspaper',
        //     }
        //   ]
        // },
        {
          label: 'Item 4',
          link: '/item-4',
          icon: 'star_rate',
          hidden: true
        }
    ];

}
